_getUserPublic